import React from 'react';

const Svg = (): React.ReactElement => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.2929 5.13568C12.6834 4.74515 12.6834 4.11199 12.2929 3.72146L12.2785 3.70711C11.888 3.31658 11.2548 3.31658 10.8643 3.70711L8.70711 5.86432C8.31658 6.25485 7.68342 6.25485 7.29289 5.86432L5.13568 3.70711C4.74515 3.31658 4.11199 3.31659 3.72146 3.70711L3.70711 3.72147C3.31658 4.11199 3.31658 4.74516 3.70711 5.13568L5.86432 7.29289C6.25484 7.68342 6.25484 8.31658 5.86432 8.70711L3.70711 10.8643C3.31658 11.2548 3.31658 11.888 3.70711 12.2785L3.72147 12.2929C4.11199 12.6834 4.74515 12.6834 5.13568 12.2929L7.29289 10.1357C7.68342 9.74515 8.31658 9.74515 8.70711 10.1357L10.8643 12.2929C11.2548 12.6834 11.888 12.6834 12.2785 12.2929L12.2929 12.2785C12.6834 11.888 12.6834 11.2548 12.2929 10.8643L10.1357 8.70711C9.74515 8.31658 9.74515 7.68342 10.1357 7.29289L12.2929 5.13568Z"
        fill="#101010"
      />
    </svg>
  );
};

export default Svg;
